import React from 'react';
import PropTypes from 'prop-types';
import {ButtonWithIcon, Dropdown, Icon} from '@/components/atoms';
import {SIZE} from '@/utils/constants/globalStyle';
import {COLOR} from '@/utils/constants/colors';
import {ButtonIcon} from '@pepsico-ds/ui';

const TargetTemplateSection = ({
  formData,
  setFormData,
  salesTarget,
  showRegularTargetUpload,
  isTargetMediaFileExist,
  numberOfLevels,
  milestones,
  handleFileDownload,
  setOpenUpload,
  cardTitle = 'Target',
  uploadButtonTitle = 'Upload Target Template',
  cardClassName = 'border-height mb-6 rounded-lg border border-solid border-[color:var(--color-border-divider)]',
  uploadButtonClassName = 'butt-size ml-2',
  titleClassName = 'pb-4 pl-3 pt-2 text-lg font-bold',
  buttonRowClassName = 'butt-icon mx-3 flex'
}) => {
  if (showRegularTargetUpload) {
    return (
      <div className={cardClassName} data-testid='target-template-card'>
        <p className={titleClassName}>{cardTitle}</p>
        <div className={buttonRowClassName}>
          <ButtonIcon
            icon='file_download'
            isDark
            onClick={() =>
              handleFileDownload(
                formData?.targetTypeValue,
                formData?.targetType
              )
            }
            size='small'
            data-testid='download-template-btn'
          />
          {isTargetMediaFileExist ? (
            <div className='main_upload-title ml-2  flex items-center rounded-lg px-2 py-3.5 text-xs'>
              <Icon
                alt='file'
                className='insert_file_icon'
                icon='insert_drive_file'
                size='small'
              />
              <p className='w-[105px] truncate pl-2'>
                {formData?.targetMediaFile?.[0]}
              </p>
              <Icon
                alt='cached'
                className='cach_ed_icon'
                icon='cached'
                size='small'
                data-testid='file-delete-icon'
                onClick={() => setOpenUpload(true)}
              />
            </div>
          ) : (
            <ButtonWithIcon
              uiSchema={{
                className: uploadButtonClassName,
                placeholder: 'Add Target Name',
                isDark: true,
                title: uploadButtonTitle,
                size: SIZE.SMALL,
                variant: COLOR.PRIMARY
              }}
              iconLeading='upload'
              handleButton={() => setOpenUpload(true)}
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className='border-target-height mb-6 rounded-lg border border-solid border-[color:var(--color-border-divider)] pb-3'>
      <p className='pb-4 pl-3 pt-2 text-lg font-bold'>Target</p>
      <div className='butt-icon mx-3 flex items-end'>
        <Dropdown
          key={'number-level'}
          isJsonWrap={false}
          isRequired={'required'}
          value={numberOfLevels.filter(
            (item) => item?.displayText == formData?.numberLevel
          )}
          childList={numberOfLevels}
          dropdownHeader={''}
          isClearable={true}
          className='number-level'
          isDark={true}
          label={'Number of Levels *'}
          selection={'single'}
          size={'medium'}
          placeholder={'Select'}
          editable={true}
          onKeyDown={(e) => {
            e.preventDefault();
          }}
          updateValue={(val) => {
            setFormData((prev) => ({
              ...prev,
              numberLevel: val?.[0]?.displayText,
              isNumberOfLevelsSelected: !val?.[0]?.displayText
            }));
          }}
        />
        <Dropdown
          key={'milestones'}
          isJsonWrap={false}
          isRequired={'required'}
          value={milestones.filter(
            (item) => item.displayText == formData?.numberMileStone
          )}
          isClearable={true}
          childList={milestones}
          dropdownHeader={''}
          className='number-miles px-4'
          isDark={true}
          label={'Number of Milestones *'}
          selection={'single'}
          onKeyDown={(e) => {
            e.preventDefault();
          }}
          updateValue={(val) => {
            setFormData((prev) => ({
              ...prev,
              numberMileStone: val?.[0]?.displayText,
              isNumberOfMilestonesSelected: !val?.[0]?.displayText
            }));
          }}
          size={'medium'}
          placeholder={'Select'}
        />

        <div className='ml-4'>
          <ButtonIcon
            icon='file_download'
            isDark
            onClick={() =>
              handleFileDownload(
                formData?.targetTypeValue,
                formData?.targetType
              )
            }
            size='medium'
            type='default'
            data-testid='file_download'
          />
        </div>
      </div>

      {isTargetMediaFileExist ? (
        <div className='layer_upload-title flex  items-center rounded-lg px-2 py-3.5 text-xs'>
          <Icon
            alt='file'
            className='insert_file_icon'
            icon='insert_drive_file'
            size='small'
          />
          <p className='w-[135px] truncate pl-2'>
            {formData?.targetMediaFile?.[0]}
          </p>
          <Icon
            alt='cached'
            className='cach_ed_icon'
            icon='cached'
            size='small'
            onClick={() => {
              // AC8: Prevent adding new stores during edit mode
              if (salesTarget?.status) {
                return;
              }
              setOpenUpload(true);
            }}
          />
        </div>
      ) : (
        <ButtonWithIcon
          uiSchema={{
            className: 'butt-size ml-3 mt-3',
            placeholder: 'Upload Target Template',
            title: 'Upload Target Template',
            size: SIZE.SMALL,
            variant: COLOR.PRIMARY,
            disabled: !!salesTarget?.status,
            disabledHelperText: salesTarget?.status
              ? 'Cannot upload new template during edit mode.'
              : undefined
          }}
          iconLeading='upload'
          handleButton={() => {
            // AC8: Prevent adding new stores during edit mode
            if (salesTarget?.status) {
              return;
            }
            setOpenUpload(true);
          }}
        />
      )}
    </div>
  );
};

TargetTemplateSection.propTypes = {
  formData: PropTypes.object,
  setFormData: PropTypes.func.isRequired,
  salesTarget: PropTypes.object,
  showRegularTargetUpload: PropTypes.bool,
  isTargetMediaFileExist: PropTypes.bool,
  numberOfLevels: PropTypes.array.isRequired,
  milestones: PropTypes.array.isRequired,
  handleFileDownload: PropTypes.func.isRequired,
  setOpenUpload: PropTypes.func.isRequired,
  cardTitle: PropTypes.string,
  uploadButtonTitle: PropTypes.string,
  cardClassName: PropTypes.string,
  uploadButtonClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  buttonRowClassName: PropTypes.string
};

export default TargetTemplateSection;
